import { createApi } from '@reduxjs/toolkit/query/react'
import { baseUrl } from './axiosInstance'
import axiosBaseQuery from './axiosBaseQuery'

const clientApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl
  }),
  reducerPath: 'clientApi',
  tagTypes: ['clientApi'],
  endpoints: () => ({})
})

export default clientApi
